import { FC } from 'react';
import type { HeatmapCellFill } from '../lib/heatmapColors';
import { HeatmapCellFillLayer } from './HeatmapCellFillLayer';

type Props = {
  /** Заливка образца; без неё образец пустой — так помечена середина шкалы */
  fill?: HeatmapCellFill | null;
  label: string;
};

/** Метка легенды: образец заливки и подпись. */
export const LegendSwatch: FC<Props> = ({ fill, label }) => (
  <span className="flex items-center gap-1.5">
    <span className="relative isolate size-3 overflow-hidden rounded-sm border border-border">
      {fill && <HeatmapCellFillLayer fill={fill} />}
    </span>
    <span className="text-xs text-muted-foreground">{label}</span>
  </span>
);
